module.exports = __webpack_public_path__ + "80af1ee2c4b1d92a9a3625a8be72e990.svg";